var parseVersion = (str) => {
	// see webpack/lib/sharing/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/sharing/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/sharing/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/sharing/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	50406: () => (loadStrictSingletonVersion("default", "react", false, [4,19,2,0], () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(14041))))))),
	67778: () => (loadStrictSingletonVersion("default", "react-dom", false, [4,19,2,0], () => (__webpack_require__.e(763).then(() => (() => (__webpack_require__(43144))))))),
	2988: () => (loadStrictSingletonVersion("default", "react-router", false, [4,7,18,4], () => (__webpack_require__.e(3203).then(() => (() => (__webpack_require__(93203))))))),
	8656: () => (loadStrictSingletonVersion("default", "@tanstack/react-query", false, [4,5,64,2], () => (__webpack_require__.e(5287).then(() => (() => (__webpack_require__(15287))))))),
	28025: () => (loadStrictSingletonVersion("default", "qwep-kit", false, [4,0,3,7], () => (__webpack_require__.e(8662).then(() => (() => (__webpack_require__(38662))))))),
	30773: () => (loadStrictSingletonVersion("default", "lodash", false, [4,4,18,1], () => (__webpack_require__.e(5250).then(() => (() => (__webpack_require__(45250))))))),
	36850: () => (loadStrictSingletonVersion("default", "react-i18next", false, [4,15,4,0], () => (__webpack_require__.e(7434).then(() => (() => (__webpack_require__(97434))))))),
	77473: () => (loadStrictSingletonVersion("default", "styled-components", false, [4,6,1,19], () => (__webpack_require__.e(3864).then(() => (() => (__webpack_require__(53864))))))),
	2582: () => (loadStrictSingletonVersion("default", "@qwep-web/ui", false, [4,1,0,0], () => (Promise.all([__webpack_require__.e(788), __webpack_require__.e(7485), __webpack_require__.e(777), __webpack_require__.e(3107), __webpack_require__.e(3499), __webpack_require__.e(8818), __webpack_require__.e(8710), __webpack_require__.e(1857), __webpack_require__.e(6355), __webpack_require__.e(6494)]).then(() => (() => (__webpack_require__(80777))))))),
	30445: () => (loadStrictVersion("default", "@package/general", false, [0], () => (Promise.all([__webpack_require__.e(7304), __webpack_require__.e(788), __webpack_require__.e(4978), __webpack_require__.e(3107), __webpack_require__.e(3499), __webpack_require__.e(3463), __webpack_require__.e(8818), __webpack_require__.e(2524), __webpack_require__.e(8710), __webpack_require__.e(1857), __webpack_require__.e(6355), __webpack_require__.e(530), __webpack_require__.e(9516), __webpack_require__.e(9108)]).then(() => (() => (__webpack_require__(39108))))))),
	30973: () => (loadStrictSingletonVersion("default", "effector-react", false, [4,23,3,0], () => (Promise.all([__webpack_require__.e(1810), __webpack_require__.e(93)]).then(() => (() => (__webpack_require__(62474))))))),
	66939: () => (loadStrictSingletonVersion("default", "socket.io-client", false, [4,4,8,4], () => (__webpack_require__.e(6949).then(() => (() => (__webpack_require__(96949))))))),
	70426: () => (loadStrictSingletonVersion("default", "effector", false, [4,23,4,4], () => (__webpack_require__.e(1810).then(() => (() => (__webpack_require__(81810))))))),
	73463: () => (loadStrictSingletonVersion("default", "@dnd-kit/utilities", false, [4,3,2,2], () => (Promise.all([__webpack_require__.e(406), __webpack_require__.e(6550)]).then(() => (() => (__webpack_require__(56550))))))),
	21857: () => (loadStrictSingletonVersion("default", "@dnd-kit/core", false, [4,6,3,1], () => (Promise.all([__webpack_require__.e(1380), __webpack_require__.e(7778), __webpack_require__.e(3463)]).then(() => (() => (__webpack_require__(81380))))))),
	78818: () => (loadStrictSingletonVersion("default", "react-hook-form", false, [4,7,80,0], () => (Promise.all([__webpack_require__.e(824), __webpack_require__.e(406)]).then(() => (() => (__webpack_require__(80824))))))),
	5744: () => (loadStrictSingletonVersion("default", "@opentelemetry/api", false, [4,1,9,1], () => (__webpack_require__.e(4239).then(() => (() => (__webpack_require__(44239))))))),
	30607: () => (loadStrictSingletonVersion("default", "@opentelemetry/semantic-conventions", false, [4,1,43,0], () => (__webpack_require__.e(7915).then(() => (() => (__webpack_require__(97915))))))),
	59516: () => (loadStrictSingletonVersion("default", "@opentelemetry/resources", false, [4,2,12,0], () => (__webpack_require__.e(1642).then(() => (() => (__webpack_require__(19261))))))),
	53107: () => (loadStrictSingletonVersion("default", "yup", false, [4,1,6,1], () => (__webpack_require__.e(8344).then(() => (() => (__webpack_require__(68344))))))),
	63499: () => (loadStrictSingletonVersion("default", "lucide-react", false, [4,1,28,0], () => (__webpack_require__.e(7700).then(() => (() => (__webpack_require__(67700))))))),
	12524: () => (loadStrictSingletonVersion("default", "formik", false, [4,2,4,6], () => (__webpack_require__.e(4381).then(() => (() => (__webpack_require__(64381))))))),
	88710: () => (loadStrictSingletonVersion("default", "clsx", false, [4,2,1,1], () => (__webpack_require__.e(4357).then(() => (() => (__webpack_require__(54357))))))),
	2641: () => (loadStrictSingletonVersion("default", "react-day-picker", false, [4,9,14,0], () => (Promise.all([__webpack_require__.e(7485), __webpack_require__.e(8701)]).then(() => (() => (__webpack_require__(58701))))))),
	35556: () => (loadStrictSingletonVersion("default", "class-variance-authority", false, [4,0,7,1], () => (__webpack_require__.e(8080).then(() => (() => (__webpack_require__(75699))))))),
	45072: () => (loadStrictSingletonVersion("default", "tailwind-merge", false, [4,3,6,0], () => (__webpack_require__.e(9073).then(() => (() => (__webpack_require__(49073))))))),
	57071: () => (loadStrictSingletonVersion("default", "@dnd-kit/modifiers", false, [4,9,0,0], () => (Promise.all([__webpack_require__.e(3463), __webpack_require__.e(5414)]).then(() => (() => (__webpack_require__(5414))))))),
	59937: () => (loadStrictSingletonVersion("default", "@dnd-kit/sortable", false, [4,10,0,0], () => (Promise.all([__webpack_require__.e(7046), __webpack_require__.e(3463)]).then(() => (() => (__webpack_require__(87046))))))),
	92817: () => (loadStrictSingletonVersion("default", "sonner", false, [4,2,0,7], () => (__webpack_require__.e(1582).then(() => (() => (__webpack_require__(91582))))))),
	1750: () => (loadStrictSingletonVersion("default", "tabulator-tables", false, [4,6,3,1], () => (__webpack_require__.e(2167).then(() => (() => (__webpack_require__(22167))))))),
	5656: () => (loadStrictSingletonVersion("default", "@opentelemetry/sdk-trace-web", false, [4,2,12,0], () => (__webpack_require__.e(8439).then(() => (() => (__webpack_require__(28439))))))),
	84492: () => (loadStrictSingletonVersion("default", "dexie", false, [4,4,0,11], () => (__webpack_require__.e(7396).then(() => (() => (__webpack_require__(67396))))))),
	99785: () => (loadStrictSingletonVersion("default", "react-window", false, [4,1,8,11], () => (__webpack_require__.e(7376).then(() => (() => (__webpack_require__(87376))))))),
	6494: () => (loadStrictSingletonVersion("default", "@hookform/resolvers", false, [4,5,4,0], () => (__webpack_require__.e(3290).then(() => (() => (__webpack_require__(87261)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"406": [
		50406
	],
	"530": [
		5744,
		30607
	],
	"1650": [
		2582,
		30445,
		30973,
		66939,
		70426
	],
	"1857": [
		21857
	],
	"2524": [
		12524
	],
	"3078": [
		2988,
		8656,
		28025,
		30773,
		36850,
		77473
	],
	"3107": [
		53107
	],
	"3463": [
		73463
	],
	"3499": [
		63499
	],
	"6355": [
		2641,
		35556,
		45072,
		57071,
		59937,
		92817
	],
	"6494": [
		6494
	],
	"7778": [
		67778
	],
	"8710": [
		88710
	],
	"8818": [
		78818
	],
	"9108": [
		1750,
		5656,
		84492,
		99785
	],
	"9516": [
		59516
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}